import { useLang } from "@/context/LanguageContext";
import { Reveal, Tag } from "@/components/portfolio/Reveal";

export const Experience = () => {
  const { t } = useLang();
  const w = t.work;
  return (
    <section id="work" data-testid="experience-timeline" className="bg-paper py-24 md:py-32">
      <div className="max-w-[88rem] mx-auto px-5 md:px-10">
        <Reveal className="flex flex-col gap-5 mb-16">
          <Tag>{w.tag}</Tag>
          <h2 className="font-extrabold text-ink text-4xl md:text-5xl tracking-tight">{w.title}</h2>
        </Reveal>

        <div className="border-l-2 border-black/[0.08] pl-6 md:pl-12">
          {w.jobs.map((job, i) => (
            <Reveal key={i} delay={0.04 * i}>
              <div className="group relative py-9 border-b border-black/[0.06] last:border-b-0">
                <span className="absolute -left-[calc(1.5rem+7px)] md:-left-[calc(3rem+7px)] top-[2.9rem] h-3 w-3 rounded-full bg-black/15 group-hover:bg-brand group-hover:scale-125 transition-all duration-400" />
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-3 lg:gap-8">
                  <div className="lg:col-span-3">
                    <span className="inline-block font-bold text-sm text-ink bg-brand/30 rounded-full px-3 py-1">{job.period}</span>
                    <p className="font-medium text-xs text-ink/50 mt-2 uppercase tracking-wide">{job.place}</p>
                  </div>
                  <div className="lg:col-span-9">
                    <h3 className="font-extrabold text-2xl md:text-3xl text-ink">{job.role}</h3>
                    <p className="font-semibold text-base text-ink/70 mt-0.5">{job.company}</p>
                    <p className="font-normal text-base text-ink/60 mt-3 max-w-3xl leading-relaxed">{job.desc}</p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
